import { render, staticRenderFns } from "./testinggdrag.vue?vue&type=template&id=a688c94c&scoped=true"
import script from "./testinggdrag.vue?vue&type=script&lang=js"
export * from "./testinggdrag.vue?vue&type=script&lang=js"
import style0 from "./testinggdrag.vue?vue&type=style&index=0&id=a688c94c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a688c94c",
  null
  
)

/* custom blocks */
import block0 from "./testinggdrag.vue?vue&type=custom&index=0&blockType=html&lang=en"
if (typeof block0 === 'function') block0(component)

export default component.exports